import domainsService from '@clubmed/domains-service';

// WARNING: iF this file is growing too much, think of replacing it with a library like Validator.js
function isPhoneNumber(stringToTest: string): boolean {
  return /^[\d\s()+-.]+$/.test(stringToTest.trim());
}

const emailRegex = new RegExp(
  /^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/,
);
const salesmanIDRegex = new RegExp(/(^\d{6,8}$|^$)/);

const getPhoneRegex = (locale?: string | null | undefined) =>
  new RegExp(
    domainsService.getDomain(locale)?.fields?.phoneNumber ||
      /^ *\+? *(?:[ \-()\.\/]*[0-9][ \-()\.\/]*){6,20}$/,
  );

const internationalPhoneRegex = new RegExp(
  /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/,
);
export { isPhoneNumber, emailRegex, getPhoneRegex, salesmanIDRegex, internationalPhoneRegex };
